import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  RosterClassesToNextAcademicYear,
  RosterStaffsToNextAcademicYear,
  RosterStudentsToNextAcademicYear,
  ClassesListForNextYear,
  StudentsListForNextYear,
  StaffsListForNextYear,
} from "./routes";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "roster",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "roster" */ "./components"),
        import(/* webpackChunkName: "roster" */ "./modules/RosterDataModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const academicYearTransitionReducer = importedModule1.default;
        injectReducer(store, {
          key: "academicYearTransition",
          reducer: academicYearTransitionReducer,
        });
        return component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
    childRoutes: [
      RosterClassesToNextAcademicYear(store),
      RosterStaffsToNextAcademicYear(store),
      RosterStudentsToNextAcademicYear(store),
      StaffsListForNextYear(store),
      StudentsListForNextYear(store),
      ClassesListForNextYear(store),
    ],
  };
};
